import { Link } from 'react-router-dom'
import logo from '../assets/logo.png'

const encodeEmail = (local, domain) => {
  const email = `${local}@${domain}`
  const label = email.split('').map((c) => `&#${c.charCodeAt(0)};`).join('')
  return { mailto: email, label }
}

export default function Footer() {
  const support = encodeEmail('support', 'tredextechnology.in')

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="logo">
              <img src={logo} alt="TRED-EX AI" className="logo-img" />
              <div className="logo-text">
                <span className="logo-title">Tredex <span className="logo-accent">AI</span></span>
                <span className="logo-subtitle">AI powered websites</span>
              </div>
            </div>
            <p>We help Businesses add intelligent AI features to their websites from AI chatbots and smart search to lead qualifiers and automated SEO. Turn your static website into an AI-powered business engine.</p>
          </div>
          <div className="footer-links">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services#chatbots">AI Chatbots</Link></li>
              <li><Link to="/services#lead-gen">Lead Generation AI</Link></li>
              <li><Link to="/services#content-ops">Content & SEO AI</Link></li>
              <li><Link to="/services">All AI Features</Link></li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
              <li><Link to="/cookies">Cookie Policy</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>Contact Info</h4>
            <p><i className="fas fa-envelope"></i> <span dangerouslySetInnerHTML={{ __html: support.label }} /></p>
            <p><i className="fas fa-phone"></i> +91 9677255272</p>
            <p><i className="fas fa-map-marker-alt"></i> Chennai, India</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 TRED-EX AI. All rights reserved.</p>
          
        </div>
      </div>
    </footer>
  )
}
